import './not-authorized.css'
import Header from "../../components/header/header";

export default function NotAuthorized(){
    return(
        <>
        <Header />
        <div className="content-wrapper pl-5 pr-5 pt-2">
            <h1 className="notAuthorized-title">403</h1>
            <h3>OOPS! VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR ESSA PÁGINA</h3>
            <p> Retorne para a página principal<a href="/home"> clique aqui.</a></p>
        </div>
        </>
    )
}